<template>
	<div class="culture">
		<div class="header">
			<div class="container">
				<div class="flex">
					<a class="logo"><img src="../../image/zsdb_logo.png" class="logoImg" style="width:132px"></a>
					<div class="menu" id="nav">
						<ul>
							<li class="menulist"><a @click="gotoHome()" class="">首页</a></li>
							<li class="menulist"><a @click="gotoCampus()" class="">校园招聘</a></li>
							<li class="menulist"><a @click="gotoSociety()" class="">社会招聘</a></li>
							<li class="menulist"><a @click="gotoIntern()" class="">实习生招聘</a></li>
							<li class="menulist"><a @click="gotoAboutus()" class="on">关于我们</a></li>
						</ul>
					</div>
					<div class="user">
						<div v-show="islogin" class="isLogin" style="display: none;">
							<div @click="gotopersonal()" style="cursor: pointer;"><span>个人中心</span></div>
							<span class="divider">|</span>
							<div @click="exit()" style="cursor: pointer;"><span> 退出</span></div>
						</div>
						<div v-show="unlogin" class="unLogin" style="display: none;">
							<div @click="gotologin()" style="cursor: pointer;"><span>登录</span></div>
							<span class="divider">|</span>
							<div @click="gotoregister()" style="cursor: pointer;"><span>注册</span></div>
						</div>
					</div>
					<el-popover class="ewm" trigger="hover" placement="bottom">
						<img src="../../image/ewm.jpg" class="code">
						<img src="../../image/icoewm.png" slot="reference" class="ico">
					</el-popover>
				</div>
			</div>
		</div>
		<div class="pagesbanner"
			style="background: url(//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_bannergy.jpg) top center no-repeat;">
			<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_gydh01.png"
				class="dh wow  fadeInLeft" style="left: 0">
			<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_gydh02.png"
				class="dh wow  fadeInLeft" style="right: 0">
			<div class="text">
				<h3>关于我们</h3>
				<p>ABOUT US</p>
			</div>
		</div>
		<div class="pagesabout">
			<div class="container">
				<div class="flex">
					<div class="aboutleft">
						<div class="item">
							<a @click="gotoAboutus()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico1.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico1on.png"
										class="icoon"></span>
								公司介绍
							</a>
						</div>
						<div class="item">
							<a @click="gotoProject()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico2.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico2on.png"
										class="icoon"></span>
								典型工程
							</a>
						</div>
						<div class="item on">
							<a @click="gotoCulture()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico3.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico3on.png"
										class="icoon"></span>
								人才培养
							</a>
						</div>
						<div class="item ">
							<a @click="gotoLife()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico4.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico4on.png"
										class="icoon"></span>
								园区生活
							</a>
						</div>
						<div class="item ">
							<a @click="gotoRecruit()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico5.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico5on.png"
										class="icoon"></span>
								招聘Q&A
							</a>
						</div>

					</div>
					<div class="aboutright">
						<div class="abouttitle">
							<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_dd.png"
								class="ico">人才培养
						</div>
						<div class="dxgc">
							<div class="lunbo">
								<div class="swiper-container swiper-gongcheng">
									<div class="swiper-wrapper">

										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_yqsh_2.png">
											<p>健身房</p>
										</div>
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_yqsh_3.png">
											<p>青年交友大联盟活动合影</p>
										</div>
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_yqsh_4.png">
											<p>全民健身活动</p>
										</div>
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_yqsh_5.png">
											<p>食堂内景</p>
										</div>
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_yqsh_6.png">
											<p>室内泳池</p>
										</div>
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_yqsh_7.png">
											<p>图书馆</p>
										</div>
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_yqsh_8.png">
											<p>园区夜景</p>
										</div>
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_yqsh_9.png">
											<p>员工篮球赛</p>
										</div>
									</div>
								</div>
								<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_zjt.png"
									class="swiper-gongcheng-prev">
								<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_yjt.png"
									class="swiper-gongcheng-next">
							</div>
							<div class="text2">华东院始终秉承“企业强盛、员工幸福”的发展理念
								，倡导“快乐工作、幸福生活”，园区内设有健身房、游泳池、运动馆、图书馆等文体设施及十余个文体协会，另有丰富多彩的趣味活动等你体验。</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<backtop></backtop>
	</div>
</template>

<script>
	import backtop from "../../components/backtop.vue"
	import {
		loginstatus,
		Logout,
	} from '../../api/user.js'
	// @ is an alias to /src
	export default {
		components: {
			backtop,
		},
		data() {
			return {
				value1: '',
				islogin: false,
				unlogin: false,
			}
		},

		mounted() {
			loginstatus().then((res) => {
				if (res.code == 200) {
					this.islogin = true;
					this.unlogin = false;
				} else if (res.code != 200) {
					this.islogin = false;
					this.unlogin = true;
				}
			})
		},

		methods: {
			exit() {
				Logout().then((res) => {
					location.reload()
				})
			},
			gotologin() {
				this.$router.push('/login')
			},
			gotoregister() {
				this.$router.push('/register')
			},
			gotoHome() {
				this.$router.push('/')
			},
			gotoAboutus() {
				this.$router.push('/aboutus/introduce')
			},
			gotoCampus() {
				this.$router.push('/campus')
			},
			gotoSociety() {
				this.$router.push('/society')
			},
			gotoIntern() {
				this.$router.push('/intern')
			},
			gotoProject() {
				this.$router.push('/aboutus/project')
			},
			// gotoCulture() {
			// 	this.$router.push('/aboutus/culture')
			// },
			gotoLife() {
				this.$router.push('/aboutus/life')
			},
			gotoRecruit() {
				this.$router.push('/aboutus/recruit')
			},
			gotopersonal() {
				this.$router.push('/personal/resume')
			},
		}
	}
</script>

<style scoped>
	@import url(../../assets/css/index.css);
</style>
